import React, { useState, useEffect } from "react";
import { tableMenuItems } from "../../adminData";
import { EllipsisVerticalIcon } from "@heroicons/react/24/outline";
import GlobalTableDropDown from "../../GlobalTableDropDown";
import Loader from "../../../../commons/Loader";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../pagination";
import { formatDate, formatTime } from "../../../../../utilities/utils";
import { getIsMHCName } from "../../../../../utilities/utils";
import { Link } from "react-router-dom";
import SkeletonTable from "../../../../commons/Skeleton/SkeletonTable";
const UserProfessionalTable = ({
  professionalData,
  getUpdateData,
  handleDropDownMenu,
}) => {
  const [showMenu, setShowMenu] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    window.addEventListener("click", handleWindowClick);
    return () => {
      window.removeEventListener("click", handleWindowClick);
    };
  }, []);

  const handleWindowClick = () => {
    setShowMenu(null);
  };

  const handleMenuItems = (userId, flag) => {
    if (!flag) {
      setShowMenu(userId.id);
    } else {
      setShowMenu(null);
    }
  };

  const handleProfessionalsNavigation = (user) => {
    navigate(`/admin-dashboard/users/${user.id}`, {
      state: {
        userInfo: user,
      },
    });
  };

  const isMHC = (user) => {
    return user?.professions[0]?.name == "Mental Health Counselor";
  };
  const { data, meta } = professionalData ?? {};
  const { current_page, last_page, per_page } = meta ?? {};

  return (
    <>
      {!data ? (
        <SkeletonTable col={10} rows={10} />
      ) : (
        <div className="border border-solid border-[#EBEFF3] rounded-md p-5 hidden md:block bg-[#ffffff]">
          <div className="flow-root">
            <div className="overflow-x-auto">
              <div className="inline-block min-w-full align-middle">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="py-3.5 pl-4 pr-3 text-left text-sm font-bold text-[#485868] leading-[160%] sm:pl-0"
                      >
                        # ID
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-bold text-[#485868] leading-[160%]"
                      >
                        Name
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-bold text-[#485868] leading-[160%]"
                      >
                        Profession
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-bold text-[#485868] leading-[160%]"
                      >
                        Email
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-bold text-[#485868] leading-[160%]"
                      >
                        Credits
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-bold text-[#485868] leading-[160%]"
                      >
                        Auto Renewal
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-bold text-[#485868] leading-[160%]"
                      >
                        Profile
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-bold text-[#485868] leading-[160%]"
                      >
                        Region(s)
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                      >
                        Status
                      </th>

                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-bold text-[#485868] leading-[160%]"
                      >
                        Date Created
                      </th>
                      <th
                        scope="col"
                        className="relative py-3.5 pl-3 pr-4 sm:pr-0"
                      >
                        <span className="sr-only"></span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {data &&
                      data.map((user, index) => (
                        <tr
                          key={user.id}
                          className="cursor-pointer hover:bg-[#EBF7FF]"
                        >
                          <Link
                            to={`/admin-dashboard/users/${user.id}`}
                            state={{ userInfo: user }}
                            className="contents"
                          >
                            <td className="whitespace-nowrap py-5 pl-4 pr-3 text-sm leading-[140%] sm:pl-0">
                              <div className="text-customGray">{user?.id}</div>
                            </td>
                            <td className="whitespace-nowrap px-3 py-5 text-sm leading-[140%]">
                              <div className="text-customGray">
                                {user?.first_name.concat(" ", user?.last_name)}
                              </div>
                            </td>
                            <td className="whitespace-nowrap px-3 py-5 text-sm leading-[140%]">
                              <div className="text-customGray">
                                {/* {user?.professions
                                ?.map((profession) => profession.name)
                                ?.join(", ")} */}
                                {isMHC(user)
                                  ? getIsMHCName(user?.professions?.[0])
                                  : user?.professions
                                      ?.map((profession) => profession.name)
                                      ?.join(", ")}
                              </div>
                            </td>
                            <td className="whitespace-nowrap px-3 py-5 text-sm leading-[140%]">
                              <div className="text-customGray">
                                {user.email}
                              </div>
                            </td>
                            <td className="whitespace-nowrap px-3 py-5 text-sm leading-[140%]">
                              <div className="text-customGray">
                                {user?.credits}
                              </div>
                            </td>
                            <td className="whitespace-nowrap px-3 py-5 text-sm leading-[140%]">
                              <div className="text-customGray">
                                {user?.credit_renew ? "On" : "Off"}
                              </div>
                            </td>
                            <td className="whitespace-nowrap px-3 py-5 text-sm leading-[140%]">
                              <div className="text-customGray">
                                {user?.profile_percentage}
                                {user?.profile_percentage && "%"}
                              </div>
                            </td>
                            <td className="whitespace-nowrap px-3 py-5 text-sm leading-[140%]">
                              <div className="text-customGray">
                                {user?.regions?.map((region, index) => (
                                  <span key={region.id}>
                                    {`${region.zip_code} ${region.city}, ${region.state} + ${region.miles}mi`}
                                    <br />
                                  </span>
                                ))}
                              </div>
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                              <span
                                className={`inline-flex items-center text-white capitalize rounded-md px-[10px] py-1 text-xs font-bold leading-[160%]`}
                                style={{ backgroundColor: user?.status?.color }}
                              >
                                {user?.status?.name ?? "---"}
                              </span>
                            </td>
                            <td className="whitespace-nowrap px-3 py-5 text-sm leading-[140%]">
                              <div className="text-customGray">
                                {formatDate(user?.created_at)} &#8226;{" "}
                                {formatTime(user?.created_at)}
                              </div>
                            </td>
                            <td>
                              <GlobalTableDropDown
                                data={user}
                                showMenu={showMenu === user.id}
                                callBack={handleMenuItems}
                                isLastIndex={index == data.length - 2}
                                menuItems={tableMenuItems}
                                handleDropDownMenu={handleDropDownMenu}
                              />
                            </td>
                          </Link>
                        </tr>
                      ))}
                  </tbody>
                </table>
                {data?.length < 1 && (
                  <h4 className="flex items-center justify-center mt-5 text-lg text-primary py-6 font-bold">
                    No Record Found.
                  </h4>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="block md:hidden">
        {!data ? (
          <SkeletonTable rows={10} col={10} />
        ) : (
          <div>
            <ul>
              {data &&
                data.map((user, index) => (
                  <li
                    className="border border-solid border-[#EBEFF3] rounded-md p-5 mb-[14px] flex justify-between bg-[#ffffff]"
                    onClick={() => handleProfessionalsNavigation(user)}
                    key={"user-" + index}
                  >
                    <ul>
                      <li className="flex items-center mb-[14px] gap-[10px]">
                        <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                          # ID
                        </h6>
                        <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                          {user?.id}
                        </span>
                      </li>
                      <li className="flex items-center mb-[14px] gap-[10px]">
                        <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                          Name
                        </h6>
                        <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                          {user?.first_name.concat(" ", user?.last_name)}
                        </span>
                      </li>
                      <li className="flex items-center mb-[14px] gap-[10px]">
                        <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                          Profession
                        </h6>
                        <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                          {isMHC(user)
                            ? getIsMHCName(user?.professions?.[0])
                            : user?.professions
                                ?.map((profession) => profession.name)
                                ?.join(", ")}
                        </span>
                      </li>
                      <li className="flex items-center mb-[14px] gap-[10px]">
                        <h6 className="w-[130px] text-sm font-bold leading-[160%] text-[#485868]">
                          Email
                        </h6>
                        <span
                          className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px] max-w-[calc(100%-110px)] xl:max-w-[calc(100%-200px)] w-full"
                          style={{ lineBreak: "anywhere" }}
                        >
                          {user?.email}
                        </span>
                      </li>
                      <li className="flex items-center mb-[14px] gap-[10px]">
                        <h6 className="w-[130px] text-sm font-bold leading-[160%] text-[#485868]">
                          Region(s)
                        </h6>
                        <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px] max-w-[calc(100%-110px)] xl:max-w-[calc(100%-200px)] w-full">
                          {user?.regions?.map((region, index) => (
                            <span key={region.id}>
                              {`${region.zip_code} ${region.city}, ${region.state} + ${region.miles}mi`}
                              <br />
                            </span>
                          ))}
                        </span>
                      </li>
                      <li className="flex items-center mb-[14px] gap-[10px]">
                        <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                          Status
                        </h6>
                        <span
                          className={`inline-flex items-center text-white capitalize rounded-md px-[10px] py-1 text-xs font-bold leading-[160%]`}
                          style={{ backgroundColor: user.status?.color }}
                        >
                          {user?.status?.name}
                        </span>
                      </li>
                      <li className="flex items-center mb-[14px] gap-[10px]">
                        <h6 className="w-[130px] text-sm font-bold leading-[160%] text-[#485868]">
                          Date Created
                        </h6>
                        <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px] max-w-[calc(100%-110px)] xl:max-w-[calc(100%-200px)] w-full">
                          {formatDate(user?.created_at)} &#8226;{" "}
                          {formatTime(user?.created_at)}
                        </span>
                      </li>
                    </ul>
                    <div>
                      <GlobalTableDropDown
                        data={user}
                        showMenu={showMenu === user.id}
                        callBack={handleMenuItems}
                        isLastIndex={index == data.length - 2}
                        menuItems={tableMenuItems}
                        handleDropDownMenu={handleDropDownMenu}
                      />
                    </div>
                  </li>
                ))}
            </ul>
            {data?.length < 1 && (
              <h4 className="flex items-center justify-center mt-5 text-lg text-primary py-6 font-bold">
                No Record Found.
              </h4>
            )}
          </div>
        )}
      </div>
      {data?.length > 0 && (
        <Pagination
          currentPage={current_page}
          totalPages={last_page}
          nextPage={getUpdateData}
          previousPage={getUpdateData}
          directIntoPage={getUpdateData}
          perPageItem={per_page}
          showNumberOfPages={3}
          meta={meta}
        />
      )}
    </>
  );
};

export default UserProfessionalTable;
